import styles from "./styles.scss";
import { FC } from "react";
import { IconButton } from "@/components";
import { Filters } from "@/assets/icons";
import clsx from "clsx";
import { FilterTriggerProps } from "./types";

export const FilterTrigger: FC<FilterTriggerProps> = ({
  onClick,
  isFilterMode,
  disabled,
}) => {
  return (
    <>
      <IconButton
        icon={Filters}
        className={clsx(
          isFilterMode && styles.panelButtonSelected,
          styles.iconWrapper,
          disabled && styles.disabled,
        )}
        onClick={onClick}
        size="small"
        disabled={disabled}
      />
      {/*{!!appliedFiltersLength && <div className={styles.buttonDot} />}*/}
    </>
  );
};
